import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { supabase } from '../../lib/supabase';
import TcnAdminLayout from '../../components/tcn-admin/TcnAdminLayout';
import ImportHistoryTable from '../../components/tcn-admin/ImportHistoryTable';
import ImportDetailModal from '../../components/tcn-admin/ImportDetailModal';

/**
 * /tcn/admin/imports — past data_imports rows for the current agency.
 * RLS scopes the SELECT automatically (data_imports policy: agency_admin/owner/tenant_admin
 * see only rows of their own agency).
 */
const TcnAdminImports = () => {
  const { t } = useTranslation();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data, error } = await supabase
          .from('data_imports')
          .select('*')
          .order('created_at', { ascending: false });
        if (!cancelled) {
          if (error) setError(error.message);
          setRows(data ?? []);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <TcnAdminLayout
      title={t('tcn.imports.title', 'Imports history')}
      subtitle={t('tcn.imports.subtitle', 'All Excel uploads for this agency, newest first.')}
    >
      {loading ? (
        <div className="rounded-xl border border-border bg-card p-8 text-center text-sm text-muted-foreground">
          {t('common.loading', 'Loading…')}
        </div>
      ) : error ? (
        <div className="rounded-xl border border-error/30 bg-error/5 p-4 text-sm text-error">{error}</div>
      ) : (
        <ImportHistoryTable rows={rows} onRowClick={setSelected} />
      )}
      <ImportDetailModal row={selected} onClose={() => setSelected(null)} />
    </TcnAdminLayout>
  );
};

export default TcnAdminImports;
